import axios from "vue-app/utils/axios.ts";
import { DTOMenuIndicatorResponse } from "vue-app/api/dto";

export const getMenuIndicators = async () => {
  const { data } = await axios.get<DTOMenuIndicatorResponse>("/menu/indicators");
  return data;
};
